import React from 'react';
import './light-box-popup.scss';
import ImageUploadInput from '../input/image-upload-input';
import { LightBoxMode } from '../../redux/storages/configuration-storage';
import PopupContent from './popup-content';

interface IProps {
  mode: LightBoxMode,
  text: string,
  image?: File,
  imageLastUploadError: boolean,
  onTextChange: (text: string) => void,
  onSelectMode: (mode: LightBoxMode) => void,
  onImageRemove: (image: File) => void,
  onImageUpload: (image: File) => void,
  t: (key: string) => string,
}

const LightBoxPopup: React.FC<IProps> = ({
                                           mode,
                                           text,
                                           image,
                                           imageLastUploadError,
                                           onTextChange,
                                           onSelectMode,
                                           onImageRemove,
                                           onImageUpload,
                                           t,
                                           ...props
                                         }) => {

  return (
    <PopupContent title={t('lightbox.editor.main.title')}>
      <ImageUploadInput
        className="cl-lightboxPopup-image"
        t={t}
        lastUploadError={imageLastUploadError}
        lastUploadFile={image}
        selectDisabled={true}
        onRemove={onImageRemove}
        onUpload={onImageUpload}
      />
    </PopupContent>
  );
};

export default LightBoxPopup;